// PROOF — Mock product catalog. Will be replaced by Shopify Storefront API in Phase 3.
// Keep field shapes close to a Shopify product so the swap is a 1:1 mapping later.

export const PRODUCTS = [
    {
        n: "001",
        slug: "field-tee-01",
        name: "Field Tee 01",
        priceEUR: 69,
        category: "tops",
        drop: "Field 001",
        badge: "New Drop",
        sizes: ["XS", "S", "M", "L", "XL"],
        materials: "100% heavy cotton · 320 gsm · garment-dyed",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p1.png",
        gallery: [
            "/assets/yk/products/p1.png",
            "/assets/yk/products/p3.png",
            "/assets/yk/products/p8.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "The starting point. A heavyweight tee built without trend, finished by hand. Wear it long enough to forget when you bought it.",
        pairWith: ["006", "005", "007"],
    },
    {
        n: "002",
        slug: "heavy-hood",
        name: "Heavy Hood",
        priceEUR: 189,
        category: "outer",
        drop: "Field 001",
        badge: null,
        sizes: ["S", "M", "L", "XL"],
        materials: "520 gsm brushed cotton · double-needle seams · matte hardware",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p2.png",
        gallery: [
            "/assets/yk/products/p2.png",
            "/assets/yk/products/p4.png",
            "/assets/yk/products/p5.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "Heavier than it needs to be. A hood built to survive its second decade — the way garments used to be made.",
        pairWith: ["005", "001", "008"],
    },
    {
        n: "003",
        slug: "crew-01",
        name: "Crew · 01",
        priceEUR: 129,
        category: "tops",
        drop: "Field 001",
        badge: null,
        sizes: ["XS", "S", "M", "L", "XL"],
        materials: "450 gsm loopback cotton · raglan seams",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p3.png",
        gallery: [
            "/assets/yk/products/p3.png",
            "/assets/yk/products/p1.png",
            "/assets/yk/products/p6.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "Loopback cotton. A quiet crew with no graphics, no logos. The cut speaks before anything else.",
        pairWith: ["005", "004", "002"],
    },
    {
        n: "004",
        slug: "work-shirt",
        name: "Work Shirt",
        priceEUR: 149,
        category: "tops",
        drop: "Field 001",
        badge: "20% Off",
        sizes: ["S", "M", "L", "XL"],
        materials: "12 oz organic cotton twill · corozo buttons",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p4.png",
        gallery: [
            "/assets/yk/products/p4.png",
            "/assets/yk/products/p5.png",
            "/assets/yk/products/p2.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "Cut from 12 oz cotton twill. Built for atelier hours, sturdy enough for the street that follows.",
        pairWith: ["005", "001", "006"],
    },
    {
        n: "005",
        slug: "cargo-pant",
        name: "Cargo Pant",
        priceEUR: 169,
        category: "bottoms",
        drop: "Field 001",
        badge: null,
        sizes: ["28", "30", "32", "34", "36"],
        materials: "14 oz washed canvas · reinforced double-knee · YKK hardware",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p5.png",
        gallery: [
            "/assets/yk/products/p5.png",
            "/assets/yk/products/p2.png",
            "/assets/yk/products/p4.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "Wide-cut, washed canvas. Reinforced where motion lives. Quiet, useful, and slow to fade.",
        pairWith: ["002", "004", "001"],
    },
    {
        n: "006",
        slug: "tape-cap",
        name: "Tape Cap",
        priceEUR: 49,
        category: "accessories",
        drop: "Field 001",
        badge: null,
        sizes: ["One Size"],
        materials: "Brushed cotton · woven tape detail · unconstructed crown",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p6.png",
        gallery: [
            "/assets/yk/products/p6.png",
            "/assets/yk/products/p8.png",
            "/assets/yk/products/p1.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "Unconstructed crown, brushed cotton, a single piece of woven tape. The smallest object in the field — the loudest in restraint.",
        pairWith: ["001", "003", "007"],
    },
    {
        n: "007",
        slug: "signal-tote",
        name: "Signal Tote",
        priceEUR: 69,
        category: "accessories",
        drop: "Field 001",
        badge: "New Product",
        sizes: ["One Size"],
        materials: "16 oz natural canvas · webbing handles · interior pocket",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p7.png",
        gallery: [
            "/assets/yk/products/p7.png",
            "/assets/yk/products/p3.png",
            "/assets/yk/products/p6.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "16 oz natural canvas. A daily carry that ages the way honest objects do — slowly, visibly, on purpose.",
        pairWith: ["006", "001", "008"],
    },
    {
        n: "008",
        slug: "quiet-tee",
        name: "Quiet Tee",
        priceEUR: 69,
        category: "tops",
        drop: "Field 001",
        badge: null,
        sizes: ["XS", "S", "M", "L", "XL"],
        materials: "240 gsm long-staple cotton · clean-finish hems",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p8.png",
        gallery: [
            "/assets/yk/products/p8.png",
            "/assets/yk/products/p1.png",
            "/assets/yk/products/p3.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "A lighter weight twin to Field Tee 01. The same hand on a finer yarn — built for the second layer.",
        pairWith: ["001", "003", "007"],
    },
    {
        n: "009",
        slug: "atelier-overshirt",
        name: "Atelier Overshirt",
        priceEUR: 219,
        category: "outer",
        drop: "Field 002 · Pre-order",
        badge: "Pre-order",
        sizes: ["S", "M", "L", "XL"],
        materials: "Boiled wool · horn buttons · half-canvas internal structure",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p4.png",
        gallery: [
            "/assets/yk/products/p4.png",
            "/assets/yk/products/p2.png",
            "/assets/yk/products/p5.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "A jacket that is also a shirt. Boiled wool, honest hardware, no need to announce itself.",
        pairWith: ["005", "001", "003"],
    },
    {
        n: "010",
        slug: "double-knee-pant",
        name: "Double-Knee Pant",
        priceEUR: 179,
        category: "bottoms",
        drop: "Field 001",
        badge: null,
        sizes: ["28", "30", "32", "34", "36"],
        materials: "13 oz raw denim · double-knee construction · selvedge edges",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p5.png",
        gallery: [
            "/assets/yk/products/p5.png",
            "/assets/yk/products/p2.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "Raw selvedge denim with a second skin at the knee. Bends with you, fades around you.",
        pairWith: ["002", "001", "006"],
    },
    {
        n: "011",
        slug: "knit-watch-cap",
        name: "Knit Watch Cap",
        priceEUR: 59,
        category: "accessories",
        drop: "Field 001",
        badge: null,
        sizes: ["One Size"],
        materials: "Merino wool · ribbed structure · woven label only",
        origin: "Knitted in Poland",
        cover: "/assets/yk/products/p6.png",
        gallery: [
            "/assets/yk/products/p6.png",
            "/assets/yk/products/p8.png",
        ],
        bgTone: "#e8e7e1",
        fieldNotes:
            "Merino wool, knitted tight. A small, useful object — the kind every wardrobe should already own.",
        pairWith: ["001", "003", "007"],
    },
    {
        n: "012",
        slug: "tote-mini",
        name: "Tote · Mini",
        priceEUR: 49,
        category: "accessories",
        drop: "Field 001",
        badge: null,
        sizes: ["One Size"],
        materials: "12 oz natural canvas · webbing handles",
        origin: "Cut, sewn & finished in Poland",
        cover: "/assets/yk/products/p7.png",
        gallery: [
            "/assets/yk/products/p7.png",
            "/assets/yk/products/p6.png",
        ],
        bgTone: "#d2d1cb",
        fieldNotes:
            "Smaller cousin to the Signal Tote. Built for the essentials — and nothing else.",
        pairWith: ["007", "006", "008"],
    },
];

export const CATEGORIES = [
    { id: "all", label: "All" },
    { id: "tops", label: "Tops" },
    { id: "outer", label: "Outer" },
    { id: "bottoms", label: "Bottoms" },
    { id: "accessories", label: "Accessories" },
];

export const SORT_OPTIONS = [
    { id: "default", label: "Default" },
    { id: "price-asc", label: "Price · Low → High" },
    { id: "price-desc", label: "Price · High → Low" },
    { id: "name-asc", label: "Name · A → Z" },
];

export const formatPrice = (eur) =>
    `€  ${eur.toFixed(2).replace(".", ",")}`;

export const getProductBySlug = (slug) =>
    PRODUCTS.find((p) => p.slug === slug) || null;

export const getProductByN = (n) => PRODUCTS.find((p) => p.n === n) || null;
